import React from "react";

interface PropertySectionProps {
  children: React.ReactNode;
  legend?: string;
  showSeparator?: boolean;
  className?: string;
}

export const PropertySection = ({
  children,
  legend,
  showSeparator = true,
  className = "",
}: PropertySectionProps) => {
  return (
    <fieldset className={`property-section ${className}`}>
      {legend && (
        <legend style={{ fontWeight: 600, fontSize: "0.8rem" }}>
          {legend}
        </legend>
      )}
      {children}
      {showSeparator && (
        <div
          className="property-section-separator"
          style={{
            height: "1px",
            backgroundColor: "var(--color-surface-low)",
            margin: "0.75rem 0 0 0",
          }}
        />
      )}
    </fieldset>
  );
}; 